{
  "links": {
    "title": "Gradex link",
    "opening": "Opening this link…",
    "unavailable": "We couldn’t reach Gradex. Check your connection and try again.",
    "inactive": {
      "title": "This link isn’t active",
      "body": "It may have expired or been turned off. If you were expecting it to work, ask the person who sent it for a new one."
    },
    "verify": {
      "title": "Confirm it’s you",
      "intro": "This link was sent to {{email}}. We’ll email a code to that address to make sure it’s you.",
      "send": "Email me a code",
      "enterTitle": "Enter the code",
      "sent": "We’ve emailed a 6-digit code to {{email}}. It expires in 10 minutes.",
      "label": "Code",
      "checking": "Checking…",
      "resend": "Send a new code",
      "resendIn": "Send a new code in {{time}}",
      "errors": {
        "incorrect_code": "That code isn’t right. Check the email and try again.",
        "expired_code": "That code has expired. Ask for a new one.",
        "locked": "Too many wrong codes. Ask for a new one.",
        "no_code": "Ask for a code first.",
        "rate_limited": "Too many tries. Please wait a little and try again.",
        "generic": "Something went wrong. Please try again."
      }
    },
    "done": {
      "title": "All done",
      "body": "You can close this page.",
      "action": "Done"
    },
    "report": {
      "action": "Report this link",
      "title": "Report this link",
      "reasonLabel": "What’s wrong?",
      "reasons": {
        "NOT_FOR_ME": "It wasn’t meant for me",
        "SUSPICIOUS": "It looks suspicious",
        "UNWANTED": "I don’t want these messages",
        "OTHER": "Something else"
      },
      "noteLabel": "Anything else we should know? (optional)",
      "send": "Send report",
      "cancel": "Cancel",
      "thanks": "Thank you. The Gradex team will look into it.",
      "failed": "We couldn’t send your report. Please try again."
    },
    "test": {
      "title": "Test link",
      "body": "This test link works: a {{level}} view of a {{subject}}."
    }
  }
}
